var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 50,
    viewBox: "0 0 174 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google Play"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    d: "M166.745 50H6.48838C2.96434 50 0.078125 47.1859 0.078125 43.75V6.25C0.078125 2.81406 2.96434 0 6.48838 0H166.745C170.269 0 173.155 2.81406 173.155 6.25V43.75C173.155 47.1859 170.269 50 166.745 50Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Border",
    d: "M166.745 1.00156C169.713 1.00156 172.128 3.35625 172.128 6.25V43.75C172.128 46.6437 169.713 48.9984 166.745 48.9984H6.48838C3.52043 48.9984 1.10537 46.6437 1.10537 43.75V6.25C1.10537 3.35625 3.52043 1.00156 6.48838 1.00156H166.745ZM166.745 0H6.48838C2.96434 0 0.078125 2.81406 0.078125 6.25V43.75C0.078125 47.1859 2.96434 50 6.48838 50H166.745C170.269 50 173.155 47.1859 173.155 43.75V6.25C173.155 2.81406 170.269 0 166.745 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4559 9.42348C13.0793 9.80786 12.8613 10.4063 12.8613 11.1813V38.825C12.8613 39.6 13.0793 40.1985 13.4559 40.5829L13.5488 40.6672L29.4366 25.1829V24.8172L13.5488 9.33286L13.4559 9.42348Z",
    fill: "url(#paint0_linear_25_377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.7276 30.3469L29.4375 25.1829V24.8172L34.734 19.6532L34.8526 19.7204L41.125 23.2C42.9151 24.1875 42.9151 25.8125 41.125 26.8063L34.8526 30.2797L34.7276 30.3469V30.3469Z",
    fill: "url(#paint1_linear_25_377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.8509 30.2797L29.4358 25L13.4551 40.5828C14.0496 41.1922 15.0192 41.2657 16.1217 40.6563L34.8509 30.2797",
    fill: "url(#paint2_linear_25_377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.8509 19.7203L16.1217 9.34376C15.0192 8.74063 14.0496 8.81407 13.4551 9.42344L29.4358 25L34.8509 19.7203Z",
    fill: "url(#paint3_linear_25_377)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GET IT ON"
  }, /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M60.8694 12.8046C60.8694 13.8484 60.5489 14.6843 59.9175 15.3077C59.1915 16.0468 58.246 16.4187 57.0873 16.4187C55.98 16.4187 55.0345 16.0405 54.2588 15.2952C53.4816 14.539 53.0938 13.6109 53.0938 12.4999C53.0938 11.389 53.4816 10.4609 54.2588 9.71086C55.0345 8.9593 55.98 8.58118 57.0873 8.58118C57.6386 8.58118 58.1643 8.69211 58.6659 8.89836C59.1659 9.10618 59.5729 9.38743 59.8678 9.7343L59.1979 10.3937C58.6835 9.80149 57.9832 9.5093 57.0873 9.5093C56.2796 9.5093 55.5793 9.7843 54.9848 10.339C54.3966 10.8952 54.1018 11.6156 54.1018 12.4999C54.1018 13.3843 54.3966 14.1109 54.9848 14.6671C55.5793 15.2155 56.2796 15.4968 57.0873 15.4968C57.9447 15.4968 58.6659 15.2155 59.2348 14.6609C59.6098 14.2937 59.8229 13.7874 59.879 13.1405H57.0873V12.2374H60.8117C60.8566 12.4327 60.8694 12.6218 60.8694 12.8046V12.8046Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M66.7778 9.67336H63.2794V12.0484H66.4333V12.9515H63.2794V15.3265H66.7778V16.2468H62.2891V8.75305H66.7778V9.67336Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M70.9487 16.2468H69.9583V9.67336H67.8125V8.75305H73.0961V9.67336H70.9487V16.2468V16.2468Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M76.9199 16.2468V8.75305H77.9087V16.2468H76.9199Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "T_2",
    d: "M82.2905 16.2468H81.3081V9.67336H79.1543V8.75305H84.4443V9.67336H82.2905V16.2468Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M94.4479 15.2827C93.6899 16.0405 92.7507 16.4187 91.6306 16.4187C90.504 16.4187 89.5649 16.0405 88.8068 15.2827C88.0504 14.5265 87.6738 13.5984 87.6738 12.4999C87.6738 11.4015 88.0504 10.4734 88.8068 9.71711C89.5649 8.9593 90.504 8.58118 91.6306 8.58118C92.7443 8.58118 93.6835 8.9593 94.4415 9.72336C95.2043 10.4859 95.5809 11.4077 95.5809 12.4999C95.5809 13.5984 95.2043 14.5265 94.4479 15.2827ZM89.5392 14.6546C90.1097 15.2155 90.8036 15.4968 91.6306 15.4968C92.4511 15.4968 93.1514 15.2155 93.7155 14.6546C94.2844 14.0937 94.5729 13.3734 94.5729 12.4999C94.5729 11.6265 94.2844 10.9062 93.7155 10.3452C93.1514 9.7843 92.4511 9.50305 91.6306 9.50305C90.8036 9.50305 90.1097 9.7843 89.5392 10.3452C88.9703 10.9062 88.6818 11.6265 88.6818 12.4999C88.6818 13.3734 88.9703 14.0937 89.5392 14.6546V14.6546Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M96.9707 16.2468V8.75305H98.1726L101.91 14.5812H101.953L101.91 13.1405V8.75305H102.899V16.2468H101.867L97.9531 10.1312H97.9098L97.9531 11.5781V16.2468H96.9707V16.2468Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Google Play_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Google Play_3",
    d: "M87.4305 27.1907C84.4193 27.1907 81.9594 29.4251 81.9594 32.5079C81.9594 35.5657 84.4193 37.8235 87.4305 37.8235C90.4482 37.8235 92.9081 35.5657 92.9081 32.5079C92.9081 29.4251 90.4482 27.1907 87.4305 27.1907ZM87.4305 35.7297C85.7783 35.7297 84.3568 34.4001 84.3568 32.5079C84.3568 30.5907 85.7783 29.2844 87.4305 29.2844C89.0828 29.2844 90.5107 30.5907 90.5107 32.5079C90.5107 34.4001 89.0828 35.7297 87.4305 35.7297V35.7297ZM75.493 27.1907C72.4754 27.1907 70.0219 29.4251 70.0219 32.5079C70.0219 35.5657 72.4754 37.8235 75.493 37.8235C78.5091 37.8235 80.9642 35.5657 80.9642 32.5079C80.9642 29.4251 78.5091 27.1907 75.493 27.1907ZM75.493 35.7297C73.8392 35.7297 72.4129 34.4001 72.4129 32.5079C72.4129 30.5907 73.8392 29.2844 75.493 29.2844C77.1453 29.2844 78.5667 30.5907 78.5667 32.5079C78.5667 34.4001 77.1453 35.7297 75.493 35.7297ZM61.2879 28.8204V31.0797H66.8216C66.6597 32.3422 66.227 33.2704 65.5635 33.9172C64.7559 34.6985 63.4978 35.5657 61.2879 35.5657C57.8825 35.5657 55.2158 32.886 55.2158 29.5657C55.2158 26.2454 57.8825 23.5657 61.2879 23.5657C63.1293 23.5657 64.469 24.2672 65.4578 25.1766L67.0908 23.5844C65.7078 22.2969 63.868 21.3079 61.2879 21.3079C56.618 21.3079 52.6934 25.0126 52.6934 29.5657C52.6934 34.1188 56.618 37.8235 61.2879 37.8235C63.8119 37.8235 65.7078 37.0172 67.1982 35.5047C68.7254 34.0157 69.2014 31.9219 69.2014 30.2313C69.2014 29.7063 69.1565 29.2235 69.0764 28.8204H61.2879ZM119.374 30.5719C118.924 29.3829 117.535 27.1907 114.705 27.1907C111.9 27.1907 109.565 29.3454 109.565 32.5079C109.565 35.486 111.876 37.8235 114.974 37.8235C117.479 37.8235 118.924 36.3344 119.519 35.4672L117.66 34.2594C117.039 35.1438 116.195 35.7297 114.974 35.7297C113.761 35.7297 112.89 35.1876 112.333 34.1188L119.626 31.1766L119.374 30.5719V30.5719ZM111.939 32.3422C111.876 30.2922 113.572 29.2422 114.786 29.2422C115.738 29.2422 116.546 29.7063 116.815 30.3704L111.939 32.3422V32.3422ZM106.011 37.5H108.408V21.8751H106.011V37.5ZM102.084 28.3751H102.004C101.466 27.7532 100.439 27.1907 99.1373 27.1907C96.4065 27.1907 93.9097 29.5282 93.9097 32.5251C93.9097 35.5047 96.4065 37.8235 99.1373 37.8235C100.439 37.8235 101.466 37.2563 102.004 36.6157H102.084V37.3782C102.084 39.411 100.971 40.5032 99.1741 40.5032C97.7094 40.5032 96.8007 39.4719 96.4257 38.6047L94.3408 39.4532C94.9417 40.8625 96.5331 42.5969 99.1741 42.5969C101.985 42.5969 104.357 40.9844 104.357 37.061V27.5141H102.084V28.3751V28.3751ZM99.3424 35.7297C97.6901 35.7297 96.3071 34.3813 96.3071 32.5251C96.3071 30.6516 97.6901 29.2844 99.3424 29.2844C100.971 29.2844 102.254 30.6516 102.254 32.5251C102.254 34.3813 100.971 35.7297 99.3424 35.7297V35.7297ZM130.599 21.8751H124.865V37.5H127.256V31.5797H130.599C133.254 31.5797 135.858 29.7063 135.858 26.7266C135.858 23.7485 133.248 21.8751 130.599 21.8751V21.8751ZM130.661 29.4063H127.256V24.0485H130.661C132.447 24.0485 133.466 25.4938 133.466 26.7266C133.466 27.936 132.447 29.4063 130.661 29.4063ZM145.442 27.161C143.714 27.161 141.918 27.9047 141.179 29.5532L143.301 30.4204C143.757 29.5532 144.597 29.2719 145.485 29.2719C146.725 29.2719 147.983 29.9985 148.003 31.2813V31.4454C147.57 31.2016 146.644 30.8407 145.504 30.8407C143.219 30.8407 140.89 32.0672 140.89 34.3563C140.89 36.4501 142.762 37.7985 144.866 37.7985C146.475 37.7985 147.363 37.0907 147.921 36.2672H148.003V37.475H150.312V31.4813C150.312 28.711 148.19 27.161 145.442 27.161ZM145.153 35.7235C144.371 35.7235 143.281 35.3454 143.281 34.4001C143.281 33.1907 144.64 32.7266 145.817 32.7266C146.87 32.7266 147.363 32.9532 148.003 33.2516C147.815 34.6985 146.538 35.7235 145.153 35.7235V35.7235ZM158.725 27.5032L155.977 34.2766H155.895L153.054 27.5032H150.475L154.745 36.9688L152.309 42.236H154.807L161.386 27.5032H158.725V27.5032ZM137.172 37.5H139.57V21.8751H137.172V37.5Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_377",
    x1: 28.026,
    y1: 39.1129,
    x2: 7.05472,
    y2: 17.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_377",
    x1: 43.456,
    y1: 24.9983,
    x2: 12.4343,
    y2: 24.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_377",
    x1: 31.9064,
    y1: 22.1299,
    x2: 3.4676,
    y2: -7.03805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_377",
    x1: 9.43239,
    y1: 49.7798,
    x2: 22.1316,
    y2: 36.7551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay1);
export default __webpack_public_path__ + "static/media/GooglePlay1.251e6383fd45747b1a1a1a2adb2b634a.svg";
export { ForwardRef as ReactComponent };